import cx from 'classnames';

import { PartialBy } from '../../../shared/utilities/types/PartialBy';
import { Typography } from '../typography/Typography';

import { ProfilePicture, ProfilePictureProps } from './ProfilePicture';
import style from './StackedProfilePicture.module.css';

export type StackedProfilePictureProps = {
    images: Array<PartialBy<ProfilePictureProps['image'], 'sizes'>>;
    totalCount?: number;
    size?: 'small' | 'medium';
};

const NB_SHOWN_PICTURES = 3;

export function StackedProfilePicture({
    images,
    totalCount,
    size = 'medium',
}: StackedProfilePictureProps) {
    const nbShownPictures = images.length > NB_SHOWN_PICTURES ? NB_SHOWN_PICTURES : images.length;
    const additionalCount = totalCount
        ? totalCount - nbShownPictures
        : images.length - nbShownPictures;
    const pictureSize = size === 'small' ? '24px' : '48px';

    return (
        <div
            className={cx(style.pictures, {
                [style.small]: size === 'small',
                [style.medium]: size === 'medium',
            })}
        >
            {images.slice(0, NB_SHOWN_PICTURES).map((image, index) => (
                <div key={index} className={style.picture}>
                    <ProfilePicture image={{ ...image, sizes: pictureSize }} />
                </div>
            ))}
            {additionalCount > 0 ? (
                <div className={style.count}>
                    <Typography
                        scale={size === 'small' ? 'primary-xxs-bold' : 'primary-xs-bold'}
                        as="span"
                    >
                        +{additionalCount}
                    </Typography>
                </div>
            ) : null}
        </div>
    );
}
